import {NgModule} from "@angular/core";
import {ProductReviewComponent} from "./product-review.component";
import {ProductReviewModalComponent} from "./product-review-modal.component";
import {SharedModule} from "../../shared.module";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ProductReviewComponent,
        ProductReviewModalComponent
    ],
    exports: [
        ProductReviewComponent,
        ProductReviewModalComponent
    ]
})
export class ProductReviewModule { }
